export const MUTATION_TYPES = {
  SET_VALIDATION_MESSAGES: 'SET_VALIDATION_MESSAGES',
  SET_RESOURCES: 'set-resources',
  SET_CURRENT_ACADEMIC_YEAR: 'set-current-academic-year',
};

export const ACTION_TYPES = {
  GET_RESOURCES: 'getResources',
  GET_CURRENT_ACADEMIC_YEAR: 'getCurrentAcademicYear',
  GET_COMMON: 'init',
};
